import { ComboLayer } from '@sprinklr/stories/widget/WidgetOptions';
import { AnalyticsRequest, Metric, GroupBy, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultWidgetPosition } from './PanelTemplatesTheme/constants';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from 'components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import {
    ComboLineOptionsImpl,
    ComboColumnOptionsImpl,
} from '../../widgets/ComboChartWidget/options';
import ListeningMetrics from '@sprinklr/stories-services/AnalyticsService/ListeningMetrics';
import { TEXT_SHADOW_DEFAULT } from 'models/Widget/Widget';

export var WidgetComboChart: Widget = {
    type: 'comboChart',
    id: 'combo-chart',
    name: 'Combo Chart - Legacy',
    useGlobalTimePeriod: true,
    useGlobalTranslate: true,
    translationLanguage: null,
    analyticsRequests: [
        // Note: All global variables like reportingEngine, report, filters, and projections
        // are injected via AnalyticsRequest.getRequests()
        new AnalyticsRequest({
            limit: 100,
            projections: [
                new Metric({
                    LISTENING: { source: ListeningMetrics.mentions },
                    INBOUND_MESSAGE: { dimensionName: 'OUTBOUND_COUNT', heading: 'Outbound Count' },
                    PLATFORM: {
                        dimensionName: 'PUBLISHED_MESSAGE_COUNT',
                        heading: 'Volume Of Published Messages',
                    },
                    BENCHMARKING: {
                        dimensionName: 'PUBLISHED_MESSAGE_COUNT',
                        heading: 'Volume Of Published Messages',
                    },
                    PAID: { dimensionName: 'spent', heading: 'Spent' },
                    ADVOCACY: {
                        dimensionName: 'ADVOCACY_ACTIVE_USERS',
                        heading: 'Total Active Users',
                    },
                    RDB_FIREHOSE: {
                        dimensionName: 'MENTIONS_COUNT',
                        heading: 'Mentions',
                    },
                    STORY_MESSAGE: {
                        dimensionName: 'NEWS_COUNT',
                        heading: 'News_Mentions',
                    },
                }),
                new Metric({
                    LISTENING: { source: ListeningMetrics.distinctUsers },
                    INBOUND_MESSAGE: { dimensionName: 'INBOUND_COUNT', heading: 'Inbound Count' },
                    PLATFORM: { dimensionName: 'TOTAL_ENGAGEMENT', heading: 'Total Engagement' },
                    BENCHMARKING: {
                        dimensionName: 'TOTAL_ENGAGEMENT',
                        heading: 'Total Engagement',
                    },
                    PAID: { dimensionName: 'clicks', heading: 'Clicks' },
                    ADVOCACY: {
                        dimensionName: 'APPROVED',
                        heading: 'Total Approved Users',
                        origReport: 'COMMUNITY_USER',
                    },
                    RDB_FIREHOSE: {
                        dimensionName: 'REACH_COUNT',
                        heading: 'Reach',
                    },
                    STORY_MESSAGE: {
                        dimensionName: 'WEB_SHARES_OVERALL',
                        heading: 'Web_shares_overall',
                    },
                }),
            ],
            groupBys: [
                new GroupBy({
                    LISTENING: { source: ListeningDimensions.day },
                    INBOUND_MESSAGE: { source: ListeningDimensions.day, dimensionName: 'snCTm' },
                    PLATFORM: { source: ListeningDimensions.day, dimensionName: 'date' },
                    BENCHMARKING: { source: ListeningDimensions.day, dimensionName: 'date' },
                    PAID: { source: ListeningDimensions.day, dimensionName: 'measurementTime' },
                    ADVOCACY: { source: ListeningDimensions.day, dimensionName: 'date' },
                    RDB_FIREHOSE: {
                        source: ListeningDimensions.day,
                        dimensionName: 'SN_CREATED_TIME',
                    },
                    STORY_MESSAGE: {
                        source: ListeningDimensions.day,
                        dimensionName: 'CREATED_TIME',
                    },
                }),
            ],
            sorts: [new Sort({ order: 'DESC', projections: 0 })],
            timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
        }) as any,
    ],
    label: {
        titleText: 'Combo Chart',
        enabled: false,
        size: WIDGET_LABEL_SIZE.primary,
        textShadow: TEXT_SHADOW_DEFAULT,
    },
    position: DefaultWidgetPosition,
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        smartSize: {
            enabled: true,
            mode: 'responsive',
            size: 'm',
        },
        comboLayers: [
            {
                name: '',
                metrics: [''],
                displayName: '',
                chartType: 'comboLine',
                options: new ComboLineOptionsImpl(),
            },
            {
                name: '',
                metrics: [''],
                displayName: '',
                chartType: 'comboColumn',
                options: new ComboColumnOptionsImpl(),
            },
        ] as ComboLayer[],
    },
};
